
const reportAbilities = (route) => {
	if (route.params.reportType == 'industry-snapshot') {
	  return [['view', 'industry-snapshot-reports']]
	} else if (route.params.reportType == 'peer-performance') {
	  return [['view', 'peer-performance-reports']]
	} else if (route.params.reportType == 'smartsearch') {
	  return [['view', 'smartsearch-reports']]
	} else {
	  return [['view', 'stack-rank-reports']]
	}
}

import {computed} from 'vue'

export default [
  {
    path: '/reporting',
    name: 'Reporting Hub',
    component: () => import('@/views/reporting/Reporting.vue'),
    meta: {
      layout: 'Default',
	  abilities: [['view', 'workspace-reporting'], ['view', 'my-reporting']]
    }
  },
  {
    path: '/reporting/:tab',
    name: 'Reporting Hub tabs',
    component: () => import('@/views/reporting/Reporting.vue'),
    meta: {
      layout: 'Default',
	  abilities: [['view', 'workspace-reporting'], ['view', 'my-reporting']]
    }
  },
  {
    path: '/reporting/:reportType(stack-rank|peer-performance|smartsearch|industry-snapshot)',
    name: 'StackRank Report List',
    component: () => import('@/views/reporting/ReportingStackRankGenericList.vue'),
    props: route => ({ 
    	reportType: route.params.reportType, 
    	title: computed(() => {
    		switch (route.params.reportType) {
    			case 'stack-rank' :
    				return 'StackRank'
    			case 'smartsearch' :
    				return 'SmartSearch'
    			case 'industry-snapshot' :
    				return 'Industry Snapshot'
    			case 'peer-performance' :
    				return 'Peer Performance'
    		}
    	})
    }),
    meta: {
      layout: 'Default',
	  abilities: route => reportAbilities(route),
	  nav: route => route.params.reportType
    }
  },
  {
    path: '/reporting/:reportType(stack-rank|peer-performance|smartsearch|industry-snapshot)/:id/:reportTab?',
    name: 'StackRank Report',
    component: () => import('@/views/reporting/ReportingStackRankDetail.vue'),
    props: true,
    meta: {
      layout: 'Default',
 	  abilities: route => reportAbilities(route),
 	  nav: route => route.params.reportType
 	}
  },
  {
    path: '/reporting/:reportType(stack-rank|peer-performance|smartsearch|industry-snapshot)/:id/:reportTab/keyword/:selectedKeyword?',
    name: 'StackRank Report - Keyword',
    component: () => import('@/views/reporting/ReportingStackRankDetail.vue'),
    props: true,
    meta: {
      layout: 'Default',
 	  abilities: route => reportAbilities(route),
	  nav: route => route.params.reportType
    }
  },
  {
    path: '/reporting/:reportType(stack-rank|peer-performance|smartsearch|industry-snapshot)/:id/:reportTab/profile/:selectedProfileUuid',
    name: 'StackRank Report - Profile',
    component: () => import('@/views/reporting/ReportingStackRankDetail.vue'),
    props: true,
    meta: {
      layout: 'Default',
	  abilities: route => reportAbilities(route),
	  nav: route => route.params.reportType
    }
  },
]